<div class="header">
    <h2>{{ 'modules.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="modules-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'modules.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'modules.form.name' | translate"
            [placeholder]="'modules.form.name.placeholder' | translate"
            inputId="name"
            testId="modules-add-name"
        />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'modules.form.description' | translate"
            [placeholder]="'modules.form.description.placeholder' | translate"
            inputId="description"
            testId="modules-add-description"
        />
    </div>

    <app-module-item-list
        [items]="selectedItems()"
        testId="modules-add-items"
        (add)="openItemDialog()"
        (remove)="removeItem($event)"
        (reorder)="reorderItems($event)"
    />
</form>

<div class="footer">
    <p-button [label]="'modules.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="modules-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'modules.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="modules-add-submit"
        (onClick)="onSubmit()"
    />
</div>
